// extracted by mini-css-extract-plugin
module.exports = {"appLayout":"AppLayout_appLayout__2XGsI"};